import { combineReducers } from "redux";

import login from "../pages/Signin/loginState";
import tenant from "./tenantState";

export default combineReducers({
  login,
  tenant,
});
